import * as tslib_1 from "tslib";
import { IGridSource, ODataGridComponent, } from '@pages/generics/grid';
import { QueueItemEventService, } from '@services';
var TransactionEventSource = /** @class */ (function () {
    function TransactionEventSource(_queueItemEvent) {
        this._queueItemEvent = _queueItemEvent;
    }
    Object.defineProperty(TransactionEventSource.prototype, "mapper", {
        get: function () {
            return this._queueItemEvent.mapper;
        },
        enumerable: true,
        configurable: true
    });
    TransactionEventSource.prototype.get = function (qo) {
        return this._queueItemEvent.getByItem(this.queueItemId, qo);
    };
    return TransactionEventSource;
}());
export { TransactionEventSource };
var TransactionEventsGridComponent = /** @class */ (function (_super) {
    tslib_1.__extends(TransactionEventsGridComponent, _super);
    function TransactionEventsGridComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TransactionEventsGridComponent.prototype, "queueItem", {
        set: function (value) {
            var svc = this._service;
            if (!!svc &&
                !!value &&
                svc.queueItemId !== value.id) {
                svc.queueItemId = value.id;
            }
        },
        enumerable: true,
        configurable: true
    });
    return TransactionEventsGridComponent;
}(ODataGridComponent));
export { TransactionEventsGridComponent };
